import { Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ImageNode.css';

interface IImageNodeProps {
  src: string;
}

export const ImageNode: React.FC<IImageNodeProps> = ({ src }) => {
  return (
    <div className={styles['wrapper']}>
      <Image src={src} width={254} />
    </div>
  );
};
